import { resolveLocalDevSfccOrigin } from '~/utils/local-dev-sfcc'

export const getRedirectUrl = () => {
  return resolveRequestOrigin() + '/auth-redirect'
}

export const getResetPasswordTokenUrl = (locale: 'en-AU' | 'en-CA' | 'en-NZ' | 'fr-CA' | '') => {
  const pathPrefix = locale ? `/${locale.split('-')[0]}` : ''
  const config = useRuntimeConfig()
  const requestOrigin = resolveRequestOrigin()
  const origin = resolveLocalDevSfccOrigin(requestOrigin, config.public.SFCC_ORGANIZATION_ID, {
    origin: config.public.SFCC_ORIGIN,
  })
  return `${origin || requestOrigin}${pathPrefix}/callback/reset-pwd-token`
}
